"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCommentContext = exports.CommentThreadAnchorType = exports.MessageType = exports.CopilotBlockedReason = exports.CopilotExperts = void 0;
var CopilotExperts;
(function (CopilotExperts) {
    CopilotExperts["generalist"] = "generalist";
    CopilotExperts["librarian"] = "librarian";
    CopilotExperts["help"] = "help";
})(CopilotExperts || (exports.CopilotExperts = CopilotExperts = {}));
/**
 * Blocked Copilot responses add additional information to the metadata
 */
exports.CopilotBlockedReason = ["anonymous", "no-credit-available"];
var MessageType;
(function (MessageType) {
    MessageType["copilotError"] = "copilotError";
    MessageType["copilotBlocked"] = "copilotBlocked";
    MessageType["docBrownError"] = "docBrownError";
    MessageType["mutableCopilotStatus"] = "mutableCopilotStatus";
    MessageType["processingCopilotStatus"] = "processingCopilotStatus";
    MessageType["finalCopilotStatus"] = "finalCopilotStatus";
})(MessageType || (exports.MessageType = MessageType = {}));
var CommentThreadAnchorType;
(function (CommentThreadAnchorType) {
    CommentThreadAnchorType["subject"] = "subject";
    CommentThreadAnchorType["document"] = "document";
    CommentThreadAnchorType["position"] = "position";
    CommentThreadAnchorType["pcb2d_position"] = "pcb2d_position";
    CommentThreadAnchorType["reply"] = "reply";
})(CommentThreadAnchorType || (exports.CommentThreadAnchorType = CommentThreadAnchorType = {}));
var DocumentCommentContext;
(function (DocumentCommentContext) {
    DocumentCommentContext["projectChat"] = "projectChat";
})(DocumentCommentContext || (exports.DocumentCommentContext = DocumentCommentContext = {}));
//# sourceMappingURL=structure.js.map